const lazyVideos = document.querySelectorAll("[data-lazy]");

if ("IntersectionObserver" in window) {
  const videoObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const video = entry.target;
        const source = video.querySelector("source");

        if (source && source.dataset.src) {
          source.src = source.dataset.src;
          video.load();
          video.play()?.catch(() => {}); 
        }

        observer.unobserve(video);
      }
    });
  });

  lazyVideos.forEach((video) => videoObserver.observe(video));
} else {
  lazyVideos.forEach((video) => {
    const source = video.querySelector("source");
    if (source && source.dataset.src) {
      source.src = source.dataset.src;
      video.load();
    }
  });
}